import { render, staticRenderFns } from "./BindCode.vue?vue&type=template&id=794def48&scoped=true&"
import script from "./BindCode.vue?vue&type=script&lang=js&"
export * from "./BindCode.vue?vue&type=script&lang=js&"
import style0 from "./BindCode.vue?vue&type=style&index=0&id=794def48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794def48",
  null
  
)

export default component.exports